// Recipe scraping utility
// Uses backend Gemini API for recipe extraction

// Backend API configuration
// In production, use relative URL since frontend and backend are on same server
const BACKEND_API_URL = process.env.NODE_ENV === 'production' 
  ? '/api/scraper'
  : (process.env.REACT_APP_SCRAPER_API_URL || 'http://localhost:3001/api/scraper');

export const scrapeRecipe = async (url) => {
  try {
    console.log('Scraping recipe from:', url);
    const backendData = await scrapeRecipeBackend(url);
    console.log('Successfully scraped using backend API');
    return backendData;
  } catch (error) {
    console.error('Error scraping recipe:', error);
    throw new Error('Failed to scrape recipe from URL. The site may not be supported or may be blocking requests.');
  }
};



export const scrapeDrink = async (url) => {
  try {
    console.log('Scraping drink recipe from:', url);
    const backendData = await scrapeDrinkBackend(url);
    console.log('Successfully scraped drink using backend API');
    return backendData;
  } catch (error) {
    console.error('Error scraping drink recipe:', error);
    throw new Error('Failed to scrape drink recipe from URL. The site may not be supported or may be blocking requests.');
  }
};

// Helper function to detect if URL is likely a recipe
export const isRecipeUrl = (url) => {
  const recipeKeywords = [
    'recipe', 'cooking', 'food', 'kitchen', 'chef', 'meal',
    'allrecipes', 'foodnetwork', 'epicurious', 'tasty'
  ];
  
  return recipeKeywords.some(keyword => 
    url.toLowerCase().includes(keyword)
  );
};

// Helper function to detect if URL is likely a drink recipe
export const isDrinkUrl = (url) => {
  const drinkKeywords = [
    'cocktail', 'drink', 'beverage', 'bar', 'mixology',
    'liquor', 'wine', 'beer', 'spirits'
  ];
  
  return drinkKeywords.some(keyword => 
    url.toLowerCase().includes(keyword)
  );
};



// Backend scraping functions
export const scrapeRecipeBackend = async (url) => {
  try {
    const response = await fetch(`${BACKEND_API_URL}/recipe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Backend scraping failed: ${response.statusText}`);
    }
    
    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('Backend recipe scraping error:', error);
    throw error;
  }
};

export const scrapeDrinkBackend = async (url) => {
  try {
    const response = await fetch(`${BACKEND_API_URL}/drink`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Backend scraping failed: ${response.statusText}`);
    }
    
    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('Backend drink scraping error:', error);
    throw error;
  }
};

export const scrapeAutoBackend = async (url) => {
  try {
    const response = await fetch(`${BACKEND_API_URL}/auto`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Backend scraping failed: ${response.statusText}`);
    }
    
    const result = await response.json();
    return { type: result.type, data: result.data };
  } catch (error) {
    console.error('Backend auto scraping error:', error);
    throw error;
  }
};

// PDF Upload Functions
export const scrapePDFRecipe = async (pdfFile) => {
  try {
    console.log('Processing PDF recipe:', pdfFile.name);
    const formData = new FormData();
    formData.append('pdf', pdfFile);

    const response = await fetch(`${BACKEND_API_URL}/pdf/recipe`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to process PDF recipe');
    }

    const result = await response.json();
    console.log('Successfully processed PDF recipe');
    return result.data;
  } catch (error) {
    console.error('PDF recipe processing error:', error);
    throw error;
  }
};

export const scrapePDFDrink = async (pdfFile) => {
  try {
    console.log('Processing PDF drink recipe:', pdfFile.name);
    const formData = new FormData();
    formData.append('pdf', pdfFile);

    const response = await fetch(`${BACKEND_API_URL}/pdf/drink`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to process PDF drink recipe');
    }

    const result = await response.json();
    console.log('Successfully processed PDF drink recipe');
    return result.data;
  } catch (error) {
    console.error('PDF drink processing error:', error);
    throw error;
  }
};

// Helper function to check if error suggests PDF upload fallback
export const shouldShowPDFUpload = (error) => {
  return error.message?.includes('Website blocks automated access') ||
         error.message?.includes('unable to access') ||
         error.message?.includes('not accessible');
};

